import { z } from 'zod';
import { claimSummarySchema, claimStatusEnumValues } from './baseClaim';
import { payorSummarySchema } from './payor';
import { tariffSummarySchema } from './tariff';

export const claimRelationshipTypeValues = [
  'RELATED',
  'SPLIT',
  'COPY',
] as const;

export const claimRelationshipSideValues = ['FROM', 'TO'] as const;

export const claimRelationshipTypeSchema = z.enum(claimRelationshipTypeValues);

export const claimRelationshipSideSchema = z.enum(claimRelationshipSideValues);

export const relatedClaimSummarySchema = claimSummarySchema
  .extend({
    serviceStart: z.iso.datetime({ offset: true }),
    status: z.enum(claimStatusEnumValues).nullable(),
    payor: payorSummarySchema.nullable(),
    tariffs: z.array(tariffSummarySchema),
  })
  .strict();

export const claimRelationshipViewSchema = z
  .object({
    id: z.guid(),
    fromClaimID: z.guid(),
    toClaimID: z.guid(),
    relationshipType: claimRelationshipTypeSchema,
    currentClaimSide: claimRelationshipSideSchema,
    relatedClaim: relatedClaimSummarySchema,
    createdBy: z.guid().nullable(),
    createdAt: z.iso.datetime({ offset: true }),
  })
  .strict();

export const listClaimRelationshipsInputSchema = z
  .object({
    claimID: z.guid(),
  })
  .strict();

export const createClaimRelationshipInputSchema = z
  .object({
    fromClaimID: z.guid(),
    toClaimID: z.guid(),
    relationshipType: claimRelationshipTypeSchema,
  })
  .strict();

export const deleteClaimRelationshipInputSchema = z
  .object({
    relationshipID: z.guid(),
  })
  .strict();

export const claimRelationshipCandidateSearchInputSchema = z
  .object({
    claimID: z.guid(),
    search: z.string().trim().max(200).default(''),
    page: z.coerce.number().int().min(0).default(0),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
  })
  .strict();

export const claimRelationshipCandidateResultSchema = z
  .object({
    data: z.array(relatedClaimSummarySchema),
    total: z.number().int().nonnegative(),
    pages: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    page: z.number().int().nonnegative(),
  })
  .strict();

export type ClaimRelationshipType = z.infer<typeof claimRelationshipTypeSchema>;
export type ClaimRelationshipSide = z.infer<typeof claimRelationshipSideSchema>;
export type RelatedClaimSummary = z.infer<typeof relatedClaimSummarySchema>;
export type ClaimRelationshipView = z.infer<typeof claimRelationshipViewSchema>;
export type CreateClaimRelationshipInput = z.infer<
  typeof createClaimRelationshipInputSchema
>;
export type ClaimRelationshipCandidateResult = z.infer<
  typeof claimRelationshipCandidateResultSchema
>;
